import {FIELD_TYPE, FORMAT_TIME} from "types/enums";

const {INPUT, AUTO_COMPLETE, DATE, COMBO_BOX, NORMAL_CHECKBOX} = FIELD_TYPE;
const fields: any[] = [
  // {
  //   type: NORMAL_CHECKBOX,
  //   label: "Bệnh nhân trong hệ thống",
  //   name: "exisPatient",
  //   wrapperCol: {xs: 12, md: 12, xl: 12, lg: 12},
  //   labelCol: {xs: 12, md: 12, xl: 12, lg: 12},
  // },
  {
    type: AUTO_COMPLETE,
    label: "Tên bệnh nhân",
    name: "hoTen",
  },
  {
    type: COMBO_BOX,
    label: "Giới tính",
    name: "gioiTinh",
    options: [
      {value: "NA", label: "Nam"},
      {value: "NU", label: "Nữ"},
    ],
    // disable: true,
  },

  {
    type: DATE,
    label: "Ngày sinh",
    name: "ngaySinh",
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "dienThoai",
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    name: "diaChi",
  },
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "maBenhNhan",
    disable: true,
  },
  {
    type: INPUT,
    label: "Mã đơn thuốc",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "BS kê đơn",
    name: "tenBacSy",
    disable: true,
  },
  {
    type: DATE,
    label: "Thời gian bán",
    name: "thoiGianBan",
    optionsTime: {showTime: true, format: FORMAT_TIME.dateTime},
    disable: true,
  },

  {
    type: COMBO_BOX,
    label: "Trạng thái",
    name: "status",
    options: [
      {value: "CB", label: "Chưa bán"},
      {value: "DB", label: "Đã bán"},
      {value: "HL", label: "Đã hoàn lại"},
    ],
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "Thanh toán",
    name: "paymentsId",
    rules: [{required: true, message: "Chưa chọn hình thức thanh toán"}],
  },

  {
    type: INPUT,
    label: "Người bán",
    name: "nguoiBan",
    value: localStorage.getItem("fullName"),
  },
];
export {fields};
